import { routeToIntake } from '../lib/intakeRouting';

const navLinks: Array<{ href: string; label: string }> = [
  { href: '#message-to-market', label: 'Message-to-Market' },
  { href: '#aeo', label: 'AEO Visibility Repair' },
  { href: '#proof-pack', label: 'Proof packs' },
  { href: '#intake', label: 'Start' },
];

export function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-obsidian/90 text-chalk backdrop-blur">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <a href="#top" className="text-2xl font-black tracking-tight">
          <span className="text-wordmark">MACELLUM</span>
        </a>

        <nav className="hidden md:block">
          <ul className="flex items-center gap-8 text-sm font-bold">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} className="text-ash transition-colors hover:text-cyan">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <button
          type="button"
          onClick={() => routeToIntake({ intent: 'm2m', productHint: 'm2m_t1' })}
          className="hidden h-10 items-center bg-cyan px-4 text-sm font-black uppercase tracking-wide text-obsidian transition hover:bg-violet hover:text-chalk md:inline-flex"
        >
          Turn proof into presence
        </button>
      </div>
    </header>
  );
}

export default Header;
